import type { ProRenderFieldPropsType } from '@ant-design/pro-provider'
import { activeBooleanValueType } from './activeBooleanValueType'
import { emailLinkValueType, faxLinkValueType, mobileLinkValueType, phoneLinkValueType } from './contactLinkValueTypes'
import { mapsLinkValueType } from './mapsLinkValueType'
import type { CustomValueTypeName } from './types'

export * from './activeBooleanValueType'
export * from './contactLinkValueTypes'
export * from './copyableConfig'
export * from './mapsLinkValueType'
export * from './TypedDescriptionsItem'
export * from './types'

// Compile-time check: every key must be a valid CustomValueTypeName with a ProRenderFieldPropsType value.
// App-level augmentations extend this map in __root.tsx — they are not checked here.
export const valueTypeMap = {
  active: activeBooleanValueType,
  mapsLink: mapsLinkValueType,
  phoneLink: phoneLinkValueType,
  mobileLink: mobileLinkValueType,
  emailLink: emailLinkValueType,
  faxLink: faxLinkValueType,
} satisfies Partial<Record<CustomValueTypeName, ProRenderFieldPropsType>>
